import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { InputButton } from '@abbott-components/core';
import { WorkflowEngineMode } from './workflowEngineReducer';

const UnsavedChangesWarningDialog = ({
  open,
  selectedTab,
  handleClose,
  handleOk
}: {
  open: boolean;
  selectedTab: WorkflowEngineMode;
  handleClose: () => void;
  handleOk: (tab: WorkflowEngineMode) => void;
}) => {
  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle
        sx={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bolder' }}
      >
        Warning
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', fontSize: '15px' }}>
        There are unsaved changes on this page.
        <br />
        Do you wish to continue?
      </DialogContent>

      <DialogActions>
        <InputButton
          name="cancelPublish"
          type="button"
          variant="text"
          onClick={handleClose}
        >
          Cancel
        </InputButton>
        <InputButton
          name="confirmPublish"
          type="button"
          variant="contained"
          onClick={() => handleOk(selectedTab)}
        >
          Ok
        </InputButton>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesWarningDialog;
